"use client";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { useTranslations } from "next-intl"


export type FeedbackStatusAction = "in_progress" | "resolved";

interface FeedbackStatusConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  action: FeedbackStatusAction | null;
  feedbackText?: string;
  onConfirm: () => void;
}

export function FeedbackStatusConfirmDialog({
  open,
  onOpenChange,
  action,
  feedbackText,
  onConfirm,
}: FeedbackStatusConfirmDialogProps) {
  const tUi = useTranslations("Ai.AiFeedbackFeedbackStatusConfirmDialog")
  const tCommonUi = useTranslations("Common")

  const isInProgress = action === "in_progress";

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            <span key={isInProgress
              ? tUi("takeFeedbackInProgress")
              : tUi("markFeedbackAsResolved")}>{isInProgress
              ? tUi("takeFeedbackInProgress")
              : tUi("markFeedbackAsResolved")}</span>
          </AlertDialogTitle>
          <AlertDialogDescription className="space-y-3">
            <span key={isInProgress
                ? tUi("thisWillMarkTheFeedbackAsBeingWorked")
                : tUi("thisWillMarkTheFeedbackAsCompletedAnd")} className="block">
              {isInProgress
                ? tUi("thisWillMarkTheFeedbackAsBeingWorked")
                : tUi("thisWillMarkTheFeedbackAsCompletedAnd")}
            </span>
            {feedbackText && (
              <span className="block p-3 bg-gray-50 rounded-md text-sm text-gray-700 border">
                "{feedbackText}"
              </span>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel><span key={tCommonUi("cancel")}>{tCommonUi("cancel")}</span></AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className={
              isInProgress
                ? "bg-blue-600 hover:bg-blue-700"
                : "bg-green-600 hover:bg-green-700"
            }
          >
            <span key={isInProgress ? tUi("takeInProgress") : tUi("markResolved")}>{isInProgress ? tUi("takeInProgress") : tUi("markResolved")}</span>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
